import _ from "lodash";
import * as Yup from "yup";
import { toUTCISOString } from "../../../utils/timeZone";

export const defaultValues = {
  name: null,
  fields: ["All"],
  emails: [],
  reportDestination: "s3",
  maxNumberOfTransactionsInCsv: null,
  reportInterval: null,
  // timezone: null,
  nextScheduleTime: null,
  reportSchedule: null,
  dateFrom: null,
  dateTo: null,
  excludeWeekends: false,
  filters: {
    brand: null,
    merchantReference: null,
    status: null,
    paymentOptionId: null,
    email: null,
  },
};
export const schema = Yup.object().shape({
  name: Yup.string().required("Scheduler name is required"),
  fields: Yup.array().of(Yup.string()).min(1, "Fields are required"),
  emails: Yup.array().of(Yup.string()).min(1, "Emails are required"),
  reportDestination: Yup.string().required("Report destination is required"),
  maxNumberOfTransactionsInCsv: Yup.number().nullable(),
  reportInterval: Yup.string().nullable(),
  // timezone: Yup.string().nullable(),
  nextScheduleTime: Yup.date().nullable(),
  reportSchedule: Yup.string().nullable(),
  dateFrom: Yup.date().nullable(),
  dateTo: Yup.date().nullable(),
  excludeWeekends: Yup.boolean(),
  filters: Yup.object()
    .shape({
      brand: Yup.string().nullable(),
      merchantReference: Yup.string().nullable(),
      status: Yup.string().nullable(),
      paymentOptionId: Yup.string().nullable(),
      email: Yup.string().nullable(),
    })
    .nullable(),
});

const sanitizeFilters = ({ brand, merchantReference, status, paymentOptionId, email }) => {
  const sanitizedFilters = _.pickBy(
    {
      brand,
      merchantReference,
      status,
      paymentOptionId,
      email,
    },
    _.identity
  );
  if (_.isEmpty(sanitizedFilters)) {
    return null;
  }
  return sanitizedFilters;
};

const sanitizeFields = (fields, allFields) => {
  if (fields && fields.includes("All")) {
    return allFields;
  }
  return fields;
};

export const sanitizeRequest = ({
  name,
  fields,
  emails,
  reportDestination,
  maxNumberOfTransactionsInCsv,
  reportInterval,
  // timezone,
  nextScheduleTime,
  reportSchedule,
  dateFrom,
  dateTo,
  excludeWeekends,
  filters,
  allFields,
}) => {
  const payload = _.pickBy(
    {
      name,
      fields: sanitizeFields(fields, allFields),
      emails,
      reportDestination,
      maxNumberOfTransactionsInCsv,
      reportInterval,
      // timezone,
      nextScheduleTime: nextScheduleTime && toUTCISOString(nextScheduleTime),
      reportSchedule,
      dateFrom: !reportSchedule && !reportInterval && dateFrom && toUTCISOString(dateFrom),
      dateTo: !reportSchedule && !reportInterval && dateTo && toUTCISOString(dateTo),
      excludeWeekends,
      filters: sanitizeFilters(filters),
    },
    _.identity
  );

  if (reportSchedule || reportInterval) {
    payload.dateFrom = null;
    payload.dateTo = null;
  }

  if (payload.dateFrom || payload.dateTo) {
    payload.reportSchedule = null;
    payload.reportInterval = null;
  }
  return payload;
};
